import { Document } from "@react-pdf/renderer";
import { PullingDesignProps } from "../../../interfaces/interfaces";
import { PullingPage } from "../pages";

export const PdfPullingReport = ({ pullingInfo }: { pullingInfo: PullingDesignProps }) => (
  <Document>
    <PullingPage pullingInfo={pullingInfo} />
  </Document>
);
